import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import PersonAvatarFace from '../PersonAvatarFace'

// Una sfida: i due giocatori ai lati e il punteggio al centro. Chi vince la sfida (a stagione finita) ha la corona.
export default function RivalryCard({ row, meId, avatars, onPress }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  const mine = row.id_challenger === meId || row.id_rival === meId
  const ended = row.status === 'ended'
  const nameOf = (id) => (id === row.id_challenger ? row.challenger_name : row.rival_name)
  const last = row.last_race
    ? t('rivalry.last_point', { name: nameOf(row.last_winner), race: row.last_race })
    : t('rivalry.no_races')
  const footer = ended
    ? (row.winner ? t('rivalry.won_by', { name: nameOf(row.winner) }) : t('rivalry.drawn'))
    : last

  const Side = ({ id, name }) => (
    <View style={s.side}>
      <View>
        <PersonAvatarFace userId={id} settings={avatars[id]} size={48} />
        {ended && row.winner === id && (
          <View style={[s.crown, { backgroundColor: tc.bgCard }]}>
            <MaterialCommunityIcons name="crown" size={14} color="#FACC15" />
          </View>
        )}
      </View>
      <Text style={[s.name, { color: id === meId ? tc.rosaText : tc.text }]} numberOfLines={2}>{name}</Text>
    </View>
  )

  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.8}
      accessibilityRole="button"
      accessibilityLabel={`${row.challenger_name} ${t('rivalry.vs')} ${row.rival_name}: ${t('rivalry.score_a11y', { a: row.wins_challenger, b: row.wins_rival })}. ${footer}`}
      style={[s.card, { backgroundColor: mine ? tc.rosaSubtle : tc.bgCard, borderColor: mine ? tc.rosaBorder : tc.border }]}
    >
      <View style={s.row}>
        <Side id={row.id_challenger} name={row.challenger_name} />
        <View style={s.center}>
          <Text style={[s.score, { color: tc.text }]}>{row.wins_challenger} – {row.wins_rival}</Text>
        </View>
        <Side id={row.id_rival} name={row.rival_name} />
      </View>
      <Text style={[s.footer, { color: tc.textMuted }]} numberOfLines={2}>{footer}</Text>
    </TouchableOpacity>
  )
}

const s = StyleSheet.create({
  card: { borderWidth: 1, borderRadius: 14, padding: 12, gap: 10 },
  row: { flexDirection: 'row', alignItems: 'center' },
  side: { flex: 1, alignItems: 'center', gap: 6 },
  center: { minWidth: 84, alignItems: 'center' },
  score: { fontFamily: fonts.condensedBold, fontSize: 30 },
  name: { fontFamily: fonts.condensedBold, fontSize: 14, textAlign: 'center' },
  crown: { position: 'absolute', right: -6, top: -6, width: 22, height: 22, borderRadius: 11, alignItems: 'center', justifyContent: 'center' },
  footer: { fontSize: 12, lineHeight: 16, textAlign: 'center' },
})
